import script from "./contentFoots-old.vue?vue&type=script&setup=true&lang=js"
export * from "./contentFoots-old.vue?vue&type=script&setup=true&lang=js"

import "./contentFoots-old.vue?vue&type=style&index=0&id=6dba59dd&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba59dd"]])

export default __exports__